import styled from 'styled-components';



export const CommentsView = styled.div`
  display: flex;
  flex-direction: column;
`;
